enum AnalyticsEnvironments {
  BYB_PRO = "BYB_PRO",
  VR = "VR",
  WEB_PORTAL = "WEB_PORTAL",
  NOT_FOUND = "NOT_FOUND",
}

export default AnalyticsEnvironments;